import React from "react";
import { VesselFinderMap } from "../VesselFinderMap";
import {
  getVesselFinderId,
  isVesselFinderTrackLink,
} from "../../utils/vesselFinderUtils";

interface AgentContainerTrackMapProps {
  trackAndTrace: string;
  height?: number;
}

export const AgentContainerTrackMap: React.FC<AgentContainerTrackMapProps> = ({
  trackAndTrace,
  height = 160,
}) => {
  const url = trackAndTrace.trim();
  if (!url || !isVesselFinderTrackLink(url)) return null;

  const vesselId = getVesselFinderId(url);
  if (vesselId) {
    return (
      <VesselFinderMap imo={vesselId} height={height} marginBottom={8} />
    );
  }

  return (
    <iframe
      src={url}
      title="VesselFinder tracking"
      style={{
        width: "100%",
        height,
        border: "none",
        borderRadius: 8,
        marginBottom: 8,
      }}
    />
  );
};
